import { Observable } from 'rxjs';
import { TrafficStation } from '../models/traffic-station.model';

/**
 * An abstract class doubling as the DI token and the contract, so the implementation bound in
 * the route's `providers` can change with no caller change.
 */
export abstract class TrafficStationRepository {
  /** Fetched once per session; the client filters by viewport in memory. */
  abstract getTrafficStations(): Observable<TrafficStation[]>;
}
